export default __webpack_public_path__ + "static/media/darlin-oh-darlin.4cfb6b94.jpg";